export const FORM_ACTIONS = {
    SAVE: Symbol("Save"),
    DELETE: Symbol("Delete"),
    GENERATE: Symbol("Generate"),
};
